import { createStore, createTypedHooks, action, Action } from 'easy-peasy'
import activityTimer, { ActivityTimerModel } from './models/activity-timer'
import datadog, { DatadogModel } from './models/datadog'
import dimensions, { DimensionsModel } from './models/dimensions'
import featureFlags, { FeatureFlagsModel } from './models/feature-flags'
import location, { LocationModel } from './models/location'
import tracking, { TrackingModel } from './models/tracking'
import offers, { OffersModel } from './models/offers'
import initialization, { InitializationModel } from './models/initialization'
import emailCapture, { EmailCaptureModel } from './models/emailCapture'
import ui, { UIModel } from './models/ui'

export interface StoreModel {
  activityTimer: ActivityTimerModel
  datadog: DatadogModel
  dimensions: DimensionsModel
  emailCapture: EmailCaptureModel
  featureFlags: FeatureFlagsModel
  location: LocationModel
  offers: OffersModel
  tracking: TrackingModel
  initialization: InitializationModel
  ui: UIModel
  reset: Action<StoreModel, any>
}

// Let's try to keep these in alphabetical order

const model: StoreModel = {
  activityTimer,
  datadog,
  dimensions,
  emailCapture,
  featureFlags,
  location,
  offers,
  tracking,
  initialization,
  ui,
  /** This is a test helper to ensure that tests are run with a clean store each time */
  reset: action((state, payload) => payload),
}

const store = createStore(model, {
  name: 'mrt-store',
})

export default store

export const { useStoreState, useStoreActions, useStoreDispatch } = createTypedHooks<StoreModel>()
